import { render, staticRenderFns } from "./EditorSlide.vue?vue&type=template&id=4beb5e9b&"
import script from "./EditorSlide.vue?vue&type=script&lang=js&"
export * from "./EditorSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports